// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1qmJl","ranges":"BmiRanges_ranges__D1Qyv"};